import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cloudsmith': {
    width: 332,
    height: 512,
    paths: [
      {
        d: 'M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1c0-46.4 37.6-84 84-84s84 37.6 84 84zM248.5 176c-46.4 0-80 33.6-80 80s-37.6 80-84 80-84-33.6-84-80 37.6-88 84-88 76-29.6 76-76 41.6-84 88-84 80 37.6 80 84-33.6 84-80 84z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cloudsmith.js
// module id = 758
// module chunks = 0